import { NotetakerPolicyUpdatePayload } from "@/schema"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { updateBookNotetakerPolicy, updateCompanyNotetakerPolicy } from "./api"
import { bookNotetakerPolicyQueryKey, COMPANY_NOTETAKER_POLICY_QUERY_KEY } from "./queries"

export function useUpdateBookNotetakerPolicy(bookId: string) {
  const queryClient = useQueryClient()
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async (payload: NotetakerPolicyUpdatePayload) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return updateBookNotetakerPolicy(context, bookId, payload)
    },
    onSuccess: (policy) => {
      queryClient.setQueryData(bookNotetakerPolicyQueryKey(bookId), policy)
      queryClient.invalidateQueries({ queryKey: ["meetings"] })
    },
  })
}

export function useUpdateCompanyNotetakerPolicy() {
  const queryClient = useQueryClient()
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async (payload: NotetakerPolicyUpdatePayload) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return updateCompanyNotetakerPolicy(context, payload)
    },
    onSuccess: (policy) => {
      queryClient.setQueryData(COMPANY_NOTETAKER_POLICY_QUERY_KEY, policy)
      queryClient.invalidateQueries({ queryKey: ["notetaker-policy"] })
      queryClient.invalidateQueries({ queryKey: ["meetings"] })
      queryClient.invalidateQueries({ queryKey: ["user", "me"] })
    },
  })
}
